package de.emgress.baskets.core.enums

enum class EIconButton(val mImageNameLight: String, val mImageNameDark: String?) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    APP_LIVETICKER("mobile-outlined.svg", null),
    SPORTDEUTSCHLAND_TV("sd-logo.svg", "sd-logo-dark.svg"),

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}